import React, { Component } from "react";
import Table from "../common/table";
import { Link } from "react-router-dom";

class UsersTable extends Component {
  columns = [
    {
      path: "name",
      label: "Name",
      content: user => <Link to={`/users/${user.id}`}>{user.name}</Link>
    },
    { path: "username", label: "Username" },
    { path: "designation", label: "Role" },
    {
      path: "active",
      label: "Active/Locked",
      content: user => <h6>{user.isActive ? "Active" : "Locked"}</h6>
    }
  ];

  render() {
    const { users, sortColumn, onSort } = this.props;
    return (
      <Table
        columns={this.columns}
        data={users}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default UsersTable;
